import './App.css';
import {useRoutes} from 'react-router-dom';
import routes from './routes/routes';

const App = () => useRoutes(routes);

export default App;
